<template>
    <Dialog ref="dialog">
        <template v-slot:title>Změna povinného parametru</template>
        <template v-slot:body>
            <div v-if="calculating" class="lead p-4 text-center">
                    <span class="spinner-border spinner-border-sm me-2 align-middle" role="status"></span>
                    Přepočítávání ...
            </div>
            <template v-else>
                <p>Změnili jste hodnotu některého z povinných parametrů.</p>
                <p>Chcete přepočítat odhad s novými nemovitostmi?</p>
            </template>
        </template>
        <template v-slot:buttons>
            <button type="button" class="btn btn-primary" @click="recalculate()" :disabled="calculating">
                Přepočítat s novými nemovitostmi
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="calculating">
                Ponechat původní nemovitosti
            </button>
        </template>
    </Dialog>
</template>

<script lang="ts">
import Dialog from '@/components/common/Dialog.vue';
import {defineComponent, ref} from 'vue';

export default defineComponent({
    components: {Dialog},
    props: {
        recalculationHandler: {
            type: Function as unknown as () => () => Promise<void>,
            required: true,
        },
    },
    setup(props, {expose}) {
        const dialog = ref<InstanceType<typeof Dialog> | null>(null);
        const calculating = ref(false);

        function show(): void {
            dialog.value!.show();
        }

        function recalculate(): void {
            calculating.value = true;

            props.recalculationHandler()
                .then(() => dialog.value!.hide())
                .finally(() => calculating.value = false);
        }

        expose({show});

        return {dialog, calculating, show, recalculate};
    },
});
</script>
